class AssistantMemories {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/assistant-memories`;

  }

  getMemories() {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, {});

  }

  deleteMemory(memoryId) {

    const path = `${this.basePath}/:memoryId`;

    return this.apiClient.delete(path, { memoryId });

  }

}

export default AssistantMemories;
